import BaseProxy from './Base';

class OutfitsProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('outfits', parameters, 'api/v1');
  }

  getOutfits(query) {
    const parameters = {};
    if (!Object.prototype.hasOwnProperty.call(query, 'page')) {
      parameters.page = 1;
    } else {
      parameters.page = query.page;
    }
    if (!Object.prototype.hasOwnProperty.call(query, 'limit')) {
      parameters.limit = 30;
    } else {
      parameters.limit = query.limit;
    }
    if (Object.prototype.hasOwnProperty.call(query, 'column')) {
      parameters.order = `${query.order === 'descending' ? '-' : ''}${query.column}`;
    } else {
      parameters.order = 'name';
    }
    this.setParameters(parameters);
    return this.load();
  }

  search(keyword) {
    this.setParameter('q', keyword);
    return this.load();
  }

  // delete(itemsIds) {
  //   const ids = Array.isArray(itemsIds) ? itemsIds : [itemsIds];
  //   return this.submit('delete', `/${this.endpoint}`, { outfits_ids: ids });
  // }
}

export default OutfitsProxy;
